class MyRlinkModelController {
  constructor (HelpersService, I18n) {
    'ngInject'
    this.HelpersService = HelpersService
    this.I18n = I18n
  }

  openTooltip ($event) {
    this.HelpersService.openTooltip($event.currentTarget)
  }

  closeTooltip () {
    this.HelpersService.closeTooltip()
  }

}

export default MyRlinkModelController



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-rlink/my-rlink-model/my-rlink-model.controller.js